import type { AttributeValidationHandler } from '../ui-element.type';
import type { UIShape } from './ui-shape';
import { BrandColors, isBrandColor } from '../../global/helpers-marketing';
import type { UIShapeLayouts } from './ui-shape.type';

/**
 * @type {UIShapeLayouts}
 */
export const UIShapeLayoutProps: UIShapeLayouts = {
    Circle: 'circle',
    Speech: 'speech',
    SpeechSquare: 'speech-square',
} as const;

/** @type {AttributeValidationHandler} */
export const validateShapeColor: AttributeValidationHandler<UIShape> = (
    component: UIShape,
    value
) => {
    const info = `Allowed options are: turquoise, lilac, pineapple, orange.`;
    if (
        Object.values(BrandColors).some((v) => ['yellow', 'blue'].includes(v))
    ) {
        console.warn(`${value} - color is deprecated. ${info}`, component);
        return;
    }
    if (!isBrandColor(value)) {
        console.warn(`${value} - value does not exist. ${info}`, component);
    }
};

/** @type {AttributeValidationHandler} */
export const validateShapeLayout: AttributeValidationHandler<UIShape> = (
    component: UIShape,
    value
) => {
    if (value === 'round') {
        const info = `Use 'circle' layout instead`;
        console.warn(`${value}} - layout is deprecated: ${info}`, component);
    }
};
